import { useState } from "react";

/*
 * Les 6 photos réelles de la clinique, jamais remplacées.
 * Si un fichier est absent, on affiche un signal « Photo à ajouter »
 * (consigne : signaler, ne pas substituer).
 */
export default function Photo({
    file,
    alt,
    legend,
    ratioClass = "",
    position = "50% 50%",
    eager = false,
    className = "",
    frameStyle,
}) {
    const [missing, setMissing] = useState(false);
    const id = file.replace(".jpg", "");

    if (missing) {
        return (
            <div
                role="img"
                aria-label={alt}
                data-testid={`photo-missing-${id}`}
                className={`photo-missing ${ratioClass} ${className}`}
            >
                <span className="badge-gold">Photo à ajouter</span>
                <span className="text-sm px-2" style={{ color: "var(--c-ink2)" }}>
                    {file} — {alt}
                </span>
            </div>
        );
    }

    return (
        <figure className={className}>
            <div className={`overflow-hidden ${ratioClass}`} style={frameStyle}>
                <picture>
                    <source srcSet={`/images/${id}.webp`} type="image/webp" />
                    <img
                        src={`/images/${file}`}
                        alt={alt}
                        loading={eager ? "eager" : "lazy"}
                        fetchPriority={eager ? "high" : undefined}
                        style={{ objectPosition: position }}
                        onError={() => setMissing(true)}
                        className="h-full w-full object-cover"
                        data-testid={`photo-${id}`}
                    />
                </picture>
            </div>
            {legend && (
                <figcaption
                    className="mt-3 text-sm"
                    style={{ color: "var(--c-ink2)" }}
                >
                    <span>{legend}</span>
                </figcaption>
            )}
        </figure>
    );
}
